// app/javascript/controllers/count_in_modal_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "leftHalf", "rightHalf", "content", "countdown", "number", "signupMessage"]

  connect() {
    console.log('here we go!')
    this.isAnimating = false
  }

  async showModalAndStart() {
    if (this.isAnimating) return

    this.isAnimating = true

    // Make element visible but transparent
    this.element.classList.remove("hidden")

    // Force reflow to ensure opacity-0 is applied before transition
    void this.overlayTarget.offsetWidth

    // Trigger fade to black
    this.overlayTarget.classList.add("modal-visible")
    this.resetModal()

    // Hide initial content, short pause, show countdown
    this.contentTarget.classList.add("hidden")
    await this.sleep(300)
    this.countdownTarget.classList.remove("hidden")

    // Wait for fade to complete (300ms) PLUS additional 300ms delay
    await this.sleep(200)
    await this.runCountdown()

    // Animate panels in
    this.leftHalfTarget.classList.add("slide-in")
    this.rightHalfTarget.classList.add("slide-in")

    await this.sleep(200)
    this.countdownTarget.classList.add("hidden")
    // Keep background black for professor mode (don't add "transparent" class)

    await this.sleep(100)
    this.splitModal()
  }

  showModal() {
    console.log('showModal')
    if (this.isAnimating) return

    this.element.classList.remove("hidden")
    this.overlayTarget.classList.add("modal-visible")

    // Reset modal state
    this.resetModal()
  }

  hideModal() {
    this.overlayTarget.classList.remove("modal-visible")
    setTimeout(() => {
      this.element.classList.add("hidden")
    }, 300)
  }

  async startCountdown() {
    if (this.isAnimating) return

    this.isAnimating = true

    // Hide content, show countdown
    this.contentTarget.classList.add("hidden")
    this.countdownTarget.classList.remove("hidden")

    // Start the countdown sequence
    await this.runCountdown()

    // Animate panels in to cover screen (number 3 stays visible until covered)
    this.leftHalfTarget.classList.add("slide-in")
    this.rightHalfTarget.classList.add("slide-in")

    // Wait for panels to cover screen
    await this.sleep(200)

    // Now hide countdown numbers since they're covered by panels
    this.countdownTarget.classList.add("hidden")

    // Make background transparent
    this.overlayTarget.classList.add("transparent")

    // Brief pause then animate panels back out
    await this.sleep(100)
    this.splitModal()
  }

  async runCountdown() {
    const numbers = [1, 2, 3]

    for (let i = 0; i < numbers.length; i++) {
      // Update number
      this.numberTarget.textContent = numbers[i]
      this.numberTarget.classList.remove("number-animate")

      // Force reflow
      void this.numberTarget.offsetWidth

      // Small delay to ensure the scale-down is visible
      await this.sleep(50)

      this.numberTarget.classList.add("number-animate")

      // Wait before next number
      if (i < numbers.length - 1) {
        await this.sleep(450)
      }
    }

    // Wait a moment after "3"
    await this.sleep(450)
  }

  hideContent() {
    this.contentTarget.classList.add('hidden');
  }

  splitModal() {
    // Add split animation classes
    this.leftHalfTarget.classList.remove("slide-in")
    this.rightHalfTarget.classList.remove("slide-in")
    this.leftHalfTarget.classList.add("slide-out-left")
    this.rightHalfTarget.classList.add("slide-out-right")

    // Show signup message as panels open
    setTimeout(() => {
      if (this.hasSignupMessageTarget) {
        this.signupMessageTarget.classList.remove("hidden")
        // Keep background black, don't hide modal - this is the end state
        this.isAnimating = false
      } else {
        // Original behavior for onboarding flow
        setTimeout(() => {
          this.hideModal()
          this.isAnimating = false
        }, 600)
      }
    }, 200)
  }

  resetModal() {
    // Reset all states - panels will return to their CSS default positions (off-screen)
    this.leftHalfTarget.classList.remove("slide-in", "slide-out-left")
    this.rightHalfTarget.classList.remove("slide-in", "slide-out-right")
    this.overlayTarget.classList.remove("transparent")

    this.contentTarget.classList.remove("hidden")
    this.countdownTarget.classList.add("hidden")

    this.numberTarget.classList.remove("number-animate")
    this.numberTarget.textContent = "1"

    if (this.hasSignupMessageTarget) {
      this.signupMessageTarget.classList.add("hidden")
    }

    this.isAnimating = false
  }

  // Close modal when clicking outside or pressing escape
  handleOverlayClick(event) {
    if (event.target === this.overlayTarget) {
      this.hideModal()
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.hideModal()
    }
  }

  // Utility function for delays
  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }
}
